<template>
  <div
    v-if="groupBy"
    id="appliedGroupingSection"
    class="d-flex align-items-center text-nowrap"
  >
    <label class="mb-0 mr-2 applied-grouping-label">Grouped By: </label>
    <div class="d-flex justify-content-space-between button-wrapper">
      <div class="d-flex badge-wrapper bg-light pb-0 applied-grouping-content">
        <div
          class="d-flex mb-1 pr-2 border-right sorting-head"
          style="flex: 1"
        >
          <b-badge
            v-if="getGroupName"
            variant="info"
            size="sm"
            class="mr-2 d-flex align-items-center grouping-item-badge"
          >
            <span class="badge-text">
              {{ getGroupName }}
            </span>
            <span
              class="ml-1 delete-filter-item"
              @click="removeGroupBy()"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </span>
          </b-badge>
          <b-badge
            v-if="getSubGroupName"
            variant="info"
            size="sm"
            class="mr-2 d-flex align-items-center grouping-item-badge"
          >
            <span class="badge-text">
              {{ getSubGroupName }}
            </span>
            <span
              class="ml-1 delete-filter-item"
              @click="removeSubGroupBy"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </span>
          </b-badge>
        </div>
        <div class="pl-2 clear-button d-flex align-items-center">
          <b-button
            id="clearGrouping"
            size="sm"
            variant="secondary"
            @click="clearAllGrouping"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
            Clear Grouping
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState} = createNamespacedHelpers('app');
const {mapGetters: mapGettersDataManagement} = createNamespacedHelpers('dataManagement');

export default {
  name: 'GroupingHeader',
  props: {
    groupBy: {
      type: String,
    },
    subGroupBy: {
      type: String,
    },
  },
  computed:{
    ...mapGettersDataManagement(['fields']),
    getGroupName() {
      return this.isItemExist('groupBy')?.name || this.groupBy;
    },
    getSubGroupName() {
      return this.isItemExist('subGroupBy')?.name || this.subGroupBy;
    },
  },
  methods: {
    removeGroupBy() {
      this.$emit('groupingChange', {groupBy: this.groupBy, isGrouped: false});
    },
    removeSubGroupBy() {
      this.$emit('groupingChange', {groupBy: this.subGroupBy, isGrouped: false});
    },
    async clearAllGrouping() {
      this.$emit('groupingChange', {groupBy: this.groupBy, isGrouped: false});
    },
    isItemExist(key) {
      return this.fields.find(el => el.fieldGuid === this[key]);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-head {
  max-width: 500px;
  overflow: auto;
}

.clear-button {
  padding-bottom: 0.3rem;
}

::-webkit-scrollbar {
  height: 7px;
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 1px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 1px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.applied-grouping-label {
  width: 100px;
}
.applied-grouping-content {
  min-width: 240px;
}
.delete-filter-item {
  display: inline-block;
  padding: 0.3rem;
  margin-right: -5px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.sorting-head {
  flex-wrap: wrap;
  gap: 1px;
}
</style>
